module.exports = __webpack_public_path__ + "img/ME.5238868f.png";